import { render, staticRenderFns } from "./ProjectOverview.vue?vue&type=template&id=edd8670a&scoped=true&"
import script from "./ProjectOverview.vue?vue&type=script&lang=js&"
export * from "./ProjectOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOverview.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProjectOverview.vue?vue&type=style&index=1&id=edd8670a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd8670a",
  null
  
)

export default component.exports